// extracted by mini-css-extract-plugin
module.exports = {"boolean__disabled":"style__boolean__disabled___DyVUX","boolean__wrapper":"style__boolean__wrapper___1p_11","boolean__label":"style__boolean__label___1uy69"};